import { footballOnServeHandler, createBaseballShortLabel, baseBallOnServeHandler, createAmricanFootbalShortLabel, } from "./helpers";
export const numberMap = {
    0: "",
    1: "First",
    2: "Second",
    3: "Third"
};
/**
 * Specifies map with key sportID and different labels and handlers
 * to handle the differences of creating the data for the UI
 */
export const sportIdMapConfig = {
    3: {
        createShortLabelHandler: createAmricanFootbalShortLabel,
        onServeHandler: footballOnServeHandler,
    },
    7: {
        createShortLabelHandler: createBaseballShortLabel,
        onServeHandler: baseBallOnServeHandler,
        decreaseIndexResult: 2,
    },
};
//# sourceMappingURL=config.js.map